module.exports = __webpack_public_path__ + "static/img/banner.6444516.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/AntiFake03/banner.png
// module id = eE57
// module chunks = 1